import { Subscription } from 'rxjs';
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FilterQuestionsService } from 'src/app/Services/filter-questions.service';

@Component({
  selector: 'app-filter-questions',
  templateUrl: './filter-questions.component.html',
  styleUrls: ['./filter-questions.component.scss']
})
export class FilterQuestionsComponent implements OnInit, OnDestroy {
  filterSub: Subscription;
  @Input() isConsumerCurriculum: boolean;
  selectedFilter: string = ''

  constructor(
    private filterQuestionsService: FilterQuestionsService
  ) { }

  ngOnInit(): void {
    this.filterSub = this.filterQuestionsService.currentFilterValue.subscribe(filterValue => {
      this.selectedFilter = filterValue;
    });
  }

  onFilterChange = (event) => {
    this.filterQuestionsService.setFilterValue(this.selectedFilter)
  }

  ngOnDestroy(): void {
    this.filterSub.unsubscribe();
  }

}
